export default () => {
  const readMore = document.querySelector('.header-infoline .read-more');
  if (!readMore) {
    return;
  }
  readMore.addEventListener('click', (event) => {
    event.currentTarget.previousElementSibling.classList.add('hide');
    event.currentTarget.classList.add('hide');
    event.currentTarget.nextElementSibling.classList.add('show');
  });
};
